import React from "react";
import className from "classnames/bind";

/**
 * Component hiển thị loading spinner
 * @param {Object} props
 * @param {string} props.message - Thông báo loading
 * @param {Object} props.styles - SCSS styles object
 */
const LoadingSpinner = ({ message = "Loading...", styles }) => {
  const cx = className.bind(styles);

  return (
    <div className={cx("loading")}>
      <div className={cx("spinner")}>
        <div className={cx("spinner-border")}></div>
      </div>
      <p>{message}</p>
    </div>
  );
};

export default LoadingSpinner;
